import twemoji from 'twemoji';

export const TWEMOJI_OPTIONS = {
  folder: 'svg',
  ext: '.svg',
  base: 'https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/',
  className: 'twemoji',
};

export function rescueEmoji(root = document.body) {
  if (!root || !twemoji?.parse) return;

  try {
    twemoji.parse(root, TWEMOJI_OPTIONS);
  } catch (e) {
    console.warn('[emoji rescue] failed:', e);
  }
}